import React, { Component } from 'react';
import { connect } from 'react-redux';

class FullPageLoader extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { loading } = this.props;
        if(!loading) return null;

        return (
            <div className="loader-container">
                <div className="loader">
                    <div class="loadingio-spinner-radio-6kqfh21w0dm"><div class="ldio-hrf0pof4vdh">
                        <div></div><div></div><div></div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        loading: state.AplicationReducer.loading,
    })
}
  
export default connect(mapStateToProps, null)(FullPageLoader);